import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { FaWhatsapp, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: ["Full-stack developer.", "React.js Developer.", "Next.js Developer.", "Node.js Developer."],
    loop: true,
    typeSpeed: 25,
    deleteSpeed: 15,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal text-black dark:text-white ">WELCOME TO MY WORLD</h4>
        <h1 className="md:text-6xl text-5xl font-bold text-black dark:text-white">
          Hi, I'm{" "}
          <span className="text-blue-600 md:inline-block block dark:text-designColor capitalize mb-2">M. Kashif Bilal</span>
        </h1>
        <h2 className="md:text-4xl sm:text-3xl text-2xl font-bold text-black dark:text-white h-[45px] ">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p className="text-base font-bodyFont leading-7 tracking-wide  text-black dark:text-white ">
          Are you willing to work with a SKILLED AND EXPERIENCED Web developer? Are you searching for one of the BEST web developers to build your website ? You're then picking the right person to get the job done RIGHT!
        </p>
      </div>
      <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
        <div className="flex flex-col md:items-start items-center">
          <h2 className="text-base uppercase font-titleFont mb-4">
            Find me in
          </h2>
          <div className="flex gap-4">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/message/NYZ4MQS2TSILJ1"
            >
              <span className="bannerIcon">
                <FaWhatsapp />
              </span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://twitter.com/KASHIF12702"
            >
              <span className="bannerIcon">
                <FaTwitter />
              </span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/kashif12702/"
            >
              <span className="bannerIcon">
                <FaLinkedinIn />
              </span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/kashif12702"
            >
              <span className="bannerIcon">
                <FaGithub />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftBanner;
